// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e0a936b9","732":"8b8d4c72","977":"de3b7e3e"}[chunkId] + ".chunk.js";
};